// extracted by mini-css-extract-plugin
export default {"teamsGrid":"TeamsTableWrapper_teamsGrid__HY3lJ"};